<template>
  <a-card :bordered="false">
    <a-form @submit="handleSubmit" :form="form">
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="单据日期"
      >
        <a-date-picker
          :format="dateFormat"
          v-decorator="[
                  'date',
                  {initialValue:formdata.date, rules: [{ required: true, message: '请选择单据日期' }]}
                ]"
        />
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="客户"
        required
      >
        <a-input-search
          @click="onCustomerSearch"
          placeholder="请选择客户"
          @search="onCustomerSearch"
          v-model="customerName"
        />
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="应收金额"
      >
        <a-input-number
          :min="1"
          :precision="2"
          v-decorator="[
                  'money',
                  {rules: [{ required: true, message: '请输入金额' }]}
                ]"
        />
      </a-form-item>
      <a-form-item
        label="备注"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-textarea
          placeholder="备注信息"
          :autosize="{ minRows: 2, maxRows: 6 }"
          v-model="formdata.note"
        />
      </a-form-item>
      <a-form-item :wrapperCol="{ xs: { span: 24 }, sm: {offset: 4, span: 20 }}">
        <a-button htmlType="submit" type="primary" :loading="state.loginBtn" :disabled="state.loginBtn">保存</a-button>
      </a-form-item>
    </a-form>
    <CustomerModal :visible="customerModalvisible" @handleCancel="customerModalCancel" @handleOk="customerModalOk"></CustomerModal>
  </a-card>
</template>
<script>
import moment from 'moment'
import CustomerModal from '@/components/Customer/Modal'
import { addProceeds } from '@/api/money'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  components: {
    CustomerModal
  },
  data () {
    return {
      dateFormat: 'YYYY-MM-DD',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      form: this.$form.createForm(this),
      state: {
        loginBtn: false
      },
      formdata: {
        date: moment(),
        customerId: '0',
        note: '',
        money: 0
      },
      customerName: '',
      customerModalvisible: false
    }
  },
  created () {
  },
  methods: {
    customerModalCancel () {
      this.customerModalvisible = false
    },
    customerModalOk (selectedRows) {
      this.customerModalvisible = false
      if (selectedRows.length > 0) {
        const rowData = selectedRows.pop()
        this.formdata.customerId = rowData.id
        this.customerName = rowData.name
      }
    },
    onCustomerSearch () {
      this.customerModalvisible = true
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const datas = Object.assign({}, this.formdata, values)
          datas.date = moment(datas.date).format(this.dateFormat)
          addProceeds(datas).then(res => {
            if (res.status !== CODE_FAIL) {
              this.$message.success('新增成功')
              this.form.resetFields()
              this.$router.push({ name: 'MoneyProceedsList' })
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style>
  .ant-input-number {
    width: 100%;
  }
</style>
